import { render, staticRenderFns } from "./DeAsideContainer.vue?vue&type=template&id=c2274eb2&scoped=true&"
import script from "./DeAsideContainer.vue?vue&type=script&lang=js&"
export * from "./DeAsideContainer.vue?vue&type=script&lang=js&"
import style0 from "./DeAsideContainer.vue?vue&type=style&index=0&id=c2274eb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2274eb2",
  null
  
)

export default component.exports